import "./styles.scss";
import { gsap } from "gsap";
// Implement Submenu Functionality

class NavFullscreen {
  constructor() {
    this.isAnimating = false;
    this.DOM = {
      submenuTogglerLinks: [...document.querySelectorAll("#full-screen-nav-modal .menu-item-has-children>a")],
      submenuHiderLinks: document.querySelectorAll(
        "#full-screen-nav-modal ul:not(.sub-menu)>li:not(.menu-item-has-children)>a"
      ),
      submenuReceiver: document.getElementById("sub-menu-receiver"),
    };

    this.addEvents();
  }
  handleMouseEnterToggler = (e) => {
    const toggleLink = e.currentTarget;
    if (this.isAnimating || toggleLink.classList.contains("active")) return;
    this.isAnimating = true;
    const subMenu = toggleLink.nextElementSibling;
    const mover = subMenu.cloneNode(true);
    this.DOM.submenuReceiver.appendChild(mover);
    const moversItems = mover.querySelectorAll("li");
    gsap.set(moversItems, { autoAlpha: 0, y: -50 });
    gsap.to(moversItems, {
      autoAlpha: 1,
      y: 0,
      stagger: 0.075,
      onComplete: () => {
        this.isAnimating = false;
        toggleLink.classList.add("active");
      },
    });
  };
  handleMouseEnterHider = (e) => {
    if (this.isAnimating) return;
    this.isAnimating = true;
    const toDelElem = document.querySelector("#sub-menu-receiver .sub-menu");
    if (toDelElem) {
      const toDelItems = toDelElem.querySelectorAll("li");
      gsap.to(toDelItems, {
        autoAlpha: 0,
        y: -50,
        stagger: 0.075,
        onComplete: () => {
          toDelElem.remove();
          this.isAnimating = false;
          this.DOM.submenuTogglerLinks.forEach((link) => link.classList.remove("active"));
        },
      });
    } else {
      this.isAnimating = false;
    }
  };
  addEvents = () => {
    this.DOM.submenuTogglerLinks.forEach((link) => {
      link.addEventListener("mousemove", this.handleMouseEnterToggler);
    });
    this.DOM.submenuHiderLinks.forEach((link) => {
      link.addEventListener("mousemove", this.handleMouseEnterHider);
    });
  };
}
export { NavFullscreen };
